// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__JfgBY","logo":"Navbar_logo__zsILa","active":"Navbar_active__SUbvn"};